import { render, staticRenderFns } from "./LanceTechInfo.vue?vue&type=template&id=31afdd02&"
import script from "./LanceTechInfo.vue?vue&type=script&lang=js&"
export * from "./LanceTechInfo.vue?vue&type=script&lang=js&"
import style0 from "./LanceTechInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports